"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonIconDisabledStyles = exports.buttonIconStyles = exports.buttonDisabledStyles = exports.buttonHoverStyles = exports.buttonStyles = exports.buttonSizeLoadingIconWithTextStyles = exports.buttonSizeLoadingIconOnlyStyles = exports.buttonSizeIconOnRightSideStyles = exports.buttonSizeIconOnLeftSideStyles = exports.buttonSizeStyles = void 0;
/**
 * The default button sizes
 */
exports.buttonSizeStyles = {
    small: {
        minHeight: "20px",
        padding: "6px 8px",
        fontSize: "14px",
        lineHeight: "20px",
        maxHeight: "32px",
    },
    medium: {
        minHeight: "24px",
        padding: "8px 12px",
        fontSize: "16px",
        lineHeight: "24px",
        maxHeight: "40px",
    },
};
/**
 * Style variant: Button with an icon on the left hand side of text
 */
exports.buttonSizeIconOnLeftSideStyles = {
    small: {
        paddingLeft: "4px",
        paddingTop: "4px",
        paddingBottom: "4px",
    },
    medium: {
        paddingLeft: "8px",
    },
};
/**
 * Style variant: Button with an icon on the right hand side of text
 */
exports.buttonSizeIconOnRightSideStyles = {
    small: {
        paddingRight: "4px",
        paddingTop: "4px",
        paddingBottom: "4px",
    },
    medium: {
        paddingRight: "8px",
    },
};
/**
 * Style variant: Loading button with only an icon no text
 */
exports.buttonSizeLoadingIconOnlyStyles = {
    small: {
        padding: "4px",
    },
    medium: {
        padding: "8px",
    },
};
/**
 * Style variant: Loading button with icon on left of text
 */
exports.buttonSizeLoadingIconWithTextStyles = {
    small: {
        padding: "4px 8px 4px 4px",
    },
    medium: {
        padding: "8px 12px 8px 8px",
    },
};
/**
 * Style variant: Button styles that align with appearance values
 */
exports.buttonStyles = {
    primary: {
        backgroundColor: "var(--ds-color-blue-100)",
        boxShadow: `inset 0 0 0 1px var(--ds-color-blue-130), inset 0px -2px 0px 0px var(--ds-color-blue-130)`,
        color: "var(--ds-color-white)",
    },
    secondary: {
        backgroundColor: "var(--ds-color-white)",
        boxShadow: `inset 0 0 0 1px var(--ds-color-silver), 0px -2px 0px 0px var(--ds-color-silver) inset`,
        color: "var(--ds-color-zinc)",
    },
    tertiary: {
        backgroundColor: "transparent",
        color: "var(--ds-color-zinc)",
    },
    "tertiary-inverted": {
        backgroundColor: "transparent",
        color: "var(--ds-color-white)",
    },
    danger: {
        backgroundColor: "var(--ds-color-red-100)",
        boxShadow: `inset 0 0 0 1px var(--ds-color-red-130), inset 0px -2px 0px 0px var(--ds-color-red-130) `,
        color: "var(--ds-color-white)",
    },
};
/**
 * Style variant: Button hover styles that align with appearance values
 */
exports.buttonHoverStyles = {
    primary: {
        backgroundColor: "var(--ds-color-blue-130)",
    },
    secondary: {
        backgroundColor: "var(--ds-color-cloud)",
    },
    tertiary: {
        backgroundColor: "hsl(237, 51%, 20%, 5%)", // night 5%
    },
    "tertiary-inverted": {
        backgroundColor: "rgba(255, 255, 255, 0.10)",
    },
    danger: { backgroundColor: "var(--ds-color-red-130)" },
};
/**
 * Style variant: Button disabled styles that align with appearance values
 */
exports.buttonDisabledStyles = {
    primary: {
        backgroundColor: "var(--ds-color-stone)",
        color: "var(--ds-color-white)",
    },
    secondary: {
        boxShadow: `inset 0 0 0 1px var(--ds-color-silver)`,
        backgroundColor: "var(--ds-color-white)",
        color: "var(--ds-color-stone)",
    },
    tertiary: {
        backgroundColor: "transparent",
        color: "var(--ds-color-stone)",
    },
    "tertiary-inverted": {
        backgroundColor: "transparent",
        color: "var(--ds-color-stone)",
    },
    danger: {
        backgroundColor: "var(--ds-color-stone)",
        color: "var(--ds-color-white)",
    },
};
/**
 * Style variant: Button icon styles that align with appearance values
 */
exports.buttonIconStyles = {
    primary: {
        fill: "var(--ds-color-white)",
    },
    secondary: {
        fill: "var(--ds-color-night)",
    },
    tertiary: {
        fill: "var(--ds-color-night)",
    },
    "tertiary-inverted": {
        fill: "var(--ds-color-white)",
    },
    danger: {
        fill: "var(--ds-color-white)",
    },
};
/**
 * Style variant: Button icon disabled styles that align with appearance values
 */
exports.buttonIconDisabledStyles = {
    primary: {
        fill: "var(--ds-color-white)",
    },
    secondary: {
        fill: "var(--ds-color-stone)",
    },
    tertiary: {
        fill: "var(--ds-color-stone)",
    },
    "tertiary-inverted": {
        fill: "var(--ds-color-stone)",
    },
    danger: {
        fill: "var(--ds-color-white)",
    },
};
//# sourceMappingURL=ButtonState.styles.js.map